import React, { Component, Fragment } from 'react';
import { OneFormConsultationForm } from './OneFormConsultationForm';
import { ConsultationFormType, SystemDistrict } from '../../../utils/enums';

export class OneFormConsultationFormContainer extends Component {
	render() {
		return (
			<Fragment>
				{this.props.items.map((item, index) => {
					let errors =
						this.props.errors &&
						this.props.errors.consultationForms &&
						this.props.errors.consultationForms.length > 0
							? this.props.errors.consultationForms[index]
							: undefined;
					return (
						<div key={`consultation-form-${index}`}>
							{item.type != ConsultationFormType.Comment && (
								<OneFormConsultationForm
									{...item}
									prefixName={`consultationForms.${index}.`}
									index={index}
									rowId={index + 1}
									projectType={this.props.projectType}
									disabled={
										this.props.disabled ||
										(this.props.availableVoteNotLogged &&
											!this.props.isAuth &&
											item.district.id !== SystemDistrict &&
											item.district.id !== this.props.notLoggedUserDistrictId)
									}
									loggedUserId={this.props.loggedUserId}
									isLegalAgeUser={this.props.isLegalAgeUser}
									onlyForLegalAge={this.props.onlyForLegalAge}
									isOnlyOneConsultationForms={this.props.isOnlyOneConsultationForms}
									isAuth={this.props.isAuth}
									availableVoteNotLogged={this.props.availableVoteNotLogged}
									onChange={this.props.onChange}
									onBlur={this.props.onBlur}
									setFieldValue={this.props.setFieldValue}
									errors={errors}
									isPreview={this.props.isPreview}
								/>
							)}
						</div>
					);
				})}
			</Fragment>
		);
	}
}

OneFormConsultationFormContainer.defaultProps = {
	disabled: false,
	loggedUserId: 0,
	projectType: 0,
	agreementAccepted: false,
	items: [],
	voteExecuting: []
};
